import { getPlatform } from "@roman/shared/utils/platform";
import { APPSTORE_URL, GOOGLE_PLAY_URL } from "./MobileAppBanner";

export const DownloadButton = () => {
  const platform = getPlatform();
  const isPC = platform === "pc";

  const handleDownload = () => {
    if (platform === "ios") {
      window.location.href = APPSTORE_URL;
    } else if (platform === "android") {
      window.location.href = GOOGLE_PLAY_URL;
    }
  };

  return (
    <button
      type="button"
      className={`bg-[#10A9FF] text-white font-bold cursor-pointer px-4 py-2 rounded-full transition-all ease-out active:scale-95 active:shadow-sm text-[12px] ${isPC ? "hover:scale-110 hover:shadow-md" : ""}`}
      onClick={handleDownload}
    >
      ダウンロード
    </button>
  );
};
